import Component from './AnalysisDocumentsBrowser.component.jsx';
import { connect } from 'react-redux';
import fromState from '../../state/selectors';
import { saveAnalysis } from '../../state/actions/AnalysisActions';

const mapStateToProps = state => {
    return {
        analysis: fromState.Analysis.getAnalysis(state),
        fetching: fromState.Analysis.isFetching(state),
        fetched: fromState.Analysis.isFetched(state),
        failed: fromState.Analysis.hasFailed(state),
        newDocument: fromState.Analysis.getNewDocument(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveAnalysis: analysis => dispatch(saveAnalysis(analysis)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...ownProps,
        ...stateProps,
        saveAnalysis: analysis => dispatchProps.saveAnalysis(analysis),
    };
};

// EXPORT CONTAINER
export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(
    Component
);
